// import { getPrivateOssTokenApi, getCommonOssTokenApi } from '@/enum/api'

/** @私库 **/
export const UPLOAD_PRIVATE_TYPE = {
    /**
     * 用户身份证
     */
    idcard: {
        value: '/user/idcard/',
        key: '201'
    },
    /**
     * 用户包赔认证
     */
    compAuth: {
        value: '/user/compensation/',
        key: '202'
    },
    /**
     * 包赔合同
     */
    compPdf: {
        value: '/order/compensation/',
        key: '203'
    },
    /**
     * dashboard报表文件-后端
     */
    dashboard: {
        value: '/report/center/',
        key: '204'
    }
}

/** @公库 **/
export const UPLOAD_COMMON_TYPE = {
    /**
     * 用户头像
     */
    avatar: {
        value: '/user/head/',
        key: '101'
    },
    /**
     * 商品封面
     */
    goodsCover: {
        value: '/goods/cover/',
        key: '103'
    },
    /**
     * 商品详情
     */
    goodsDetail: {
        value: '/goods/detail/',
        key: '104'
    },
    /**
     * 游戏图标
     */
    gameIcon: {
        value: '/goods/detail/',
        key: '105'
    },
    /**
     * 黑号举报、售后、投诉客服等附属业务
     */
    service: {
        value: '/service/',
        key: '106'
    },
    /**
     * im聊天消息 图片视频文件
     */
    imMessage: {
        value: '/im/message/',
        key: '107'
    },
    /**
     * im会话信息 头像
     */
    imConversation: {
        value: '/im/conversationInfo/',
        key: '108'
    },
    /**
     * app展示图片： banner 等
     */
    appDisplay: {
        value: '/app/display/',
        key: '109'
    }
}

/** @配置 **/
export const UPLOAD_CONFIG = {
    // 私库
    private: {
        prefix: 'p/2', // 前缀
        uploadTypes: UPLOAD_PRIVATE_TYPE, // 私库类型
        // getTokenApi: getPrivateOssTokenApi // 获取stsToken接口
    },
    // 公库
    common: {
        prefix: 'c/2', // 前缀
        uploadTypes: UPLOAD_COMMON_TYPE, // 公库类型
        // getTokenApi: getCommonOssTokenApi // 获取stsToken接口
    }
}
